import Table from 'react-bootstrap/Table';
import Sites from './OverviewSites';

const Organizations  = ({config, measurements, history, userOrg, userLevel, main_callback}) => {
    //console.log('organizations', userOrg)
  
    if (config) {
      // Valitaan ainoastaan tietyn organisaation sitet. Huom! 0=All, ja haetaan kaikki sitet.
      const filteredConfig = (userOrg === 0) ? config : config.filter((item) => item['id'] === userOrg);

      return (
          <>

{/*            <Table bordered striped hover info="true"> */}
            <Table>
              <thead>
              </thead>
    
              <tbody>
                {

                  //config.map((item, index) => {
                  filteredConfig.map((item, index) => {
                    // TODO: Organisaation valinnassa otettava huomioon mitä kaikkea käyttäjä voi nähdä. Tässä vaiheessa testissä HSY näkee ainoastan omansa ja Savcor kaikki
                    //if (item['id'] !== userOrg)
                    //  continue;

                    var config_sites = item['sites'];
                    //console.log('config_sites', item)


                    return (
                      <>
                      <div><h2><b>{item['name']}</b></h2></div>

                      <Sites key={index} config={config_sites} measurements={measurements} history={history} userLevel={userLevel} main_callback={main_callback}></Sites>
                      </>
                    )
                  })




                }
              </tbody>
    
    
              </Table>
          </>
    )
  
  }
  }
  
  //const sleep = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));

export default Organizations